export var shareBlogButtonClick = function shareBlogButtonClick(_ref, _ref2) {
  var socialName = _ref.socialName;
  var structure = _ref2.structure;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "blog-".concat(structure == null ? void 0 : structure.id, ":redes-sociais"),
    eventLabel: "".concat(socialName)
  };
};